import { render, staticRenderFns } from "./FiasInfo.vue?vue&type=template&id=addccd64&"
import script from "./FiasInfo.vue?vue&type=script&lang=js&"
export * from "./FiasInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports